import '../../settings'
import Vue from 'vue'

export default {

    geolocate (data) {

        console.log('--- maps_api.js geolocate data: ')
        console.log(data)
        console.log('----------')

        return new Promise((resolve, reject) => {

            // geocode api key
            const api_key = 'AIzaSyB__K_9Sk2AOlY8rJKWPy7XYuWRASaWxDU'
            const address = data.street_name + ', ' + data.street_number + ', ' + data.municipality.name_ine
            const postUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=' + api_key

            Vue.http.post(postUrl, null, {
                emulateHTTP: true, headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
                .then(res => resolve(
                    {
                        results: res.body.results,
                        lat: res.body.results[0].geometry.location.lat,
                        lng: res.body.results[0].geometry.location.lng,
                        formatted_address: res.body.results[0].formatted_address,
                        street_number: parseInt(res.body.results[0].address_components[0].long_name),
                        street_name: res.body.results[0].address_components[1].long_name,
                        municipality: res.body.results[0].address_components[2].long_name,
                        province: res.body.results[0].address_components[3].long_name,
                        region: res.body.results[0].address_components[4].long_name,
                        country: res.body.results[0].address_components[5].long_name,
                        postal_code: res.body.results[0].address_components[6].long_name,
                        viewport: res.body.results[0].geometry.viewport
                    }), res => {
                    console.error(res.body)
                })

        })
    },
    googledistance (data) {

        console.log('--- maps_api.js distance data: ')
        console.log(data)
        console.log('----------')

        return new Promise((resolve, reject) => {

            // we don't have yet a key for distancematrix api
            const api_key = ''
            const origin = 'Carrer de Còrsega, 168, Barcelona'
            const destination = data.street_name + ', ' + data.street_number + ', ' + data.municipality.name_ine
            const mode = 'driving'
            const postUrl = 'https://maps.googleapis.com/maps/api/distancematrix/json?origins=' + origin + '&destinations=' + destination + '&key=' + api_key

            Vue.http.post(postUrl, null, {
                emulateHTTP: true, headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
                .then(res => resolve(
                    {
                        results: res
                    }), res => {
                    console.error(res.body)
                })

        })

        // const url = 'https://maps.googleapis.com/maps/api/directions/json?origin='+origin+'&destination='+destination+'&mode='+mode+'+&key=' + api_key

        /*
        const url = 'https://us-central1-barnatasa5.cloudfunctions.net/googledistance?destination='+destination

        Vue.http.get(url, null, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        })
            */

    }
    ,
    request_icc_census_section_info (data) {

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=

        const dist = 600
        const coord_a1 = data.x - (dist / 2)
        const coord_a2 = data.y - (dist / 2)
        const coord_b1 = data.x + (dist / 2)
        const coord_b2 = data.y + (dist / 2)

        const bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2

        return new Promise((resolve, reject) => {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            const url = 'https://us-central1-barnatasa5.cloudfunctions.net/icc_census_section_info_by_bbox?bbox=' + bbox
            Vue.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
                .then(res => resolve(
                    {
                        html: res.body

                    }), res => {
                    console.error(res.body)
                })

        })
    }
    ,
    request_idescat_info_by_code_ine (data) {

        return new Promise((resolve, reject) => {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            const url = 'https://us-central1-barnatasa5.cloudfunctions.net/idescat_info_by_code_ine?code_ine=' + data.code_ine

            Vue.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
                .then(res => resolve(
                    {
                        html: res.body

                    }), res => {
                    console.error(res.body)
                })

        })
    }
    ,
    request_muc_info (data) {

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=

        const dist = 600
        const coord_a1 = data.x - (dist / 2)
        const coord_a2 = data.y - (dist / 2)
        const coord_b1 = data.x + (dist / 2)
        const coord_b2 = data.y + (dist / 2)

        const bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2

        return new Promise((resolve, reject) => {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            const url = 'https://us-central1-barnatasa5.cloudfunctions.net/muc_info_by_bbox?bbox=' + bbox
            Vue.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
                .then(res => resolve(
                    {
                        html: res.body

                    }), res => {
                    console.error(res.body)
                    reject()
                })

        })
    }
    ,
    request_map_urban_muc_land_colors_by_bbox (data) {

        console.log('request_muc_map data in maps_api.js: ')
        console.log(data)

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=

        const factor = 0.2
        const width = data.width * data.zoom * factor
        const height = data.height * data.zoom * factor
        const coord_a1 = data.x - (width / 2)
        const coord_a2 = data.y - (height / 2)
        const coord_b1 = data.x + (width / 2)
        const coord_b2 = data.y + (height / 2)

        const bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2

        return new Promise((resolve, reject) => {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            const url = 'https://us-central1-barnatasa5.cloudfunctions.net/map_urban_muc_land_colors_by_bbox?bbox=' + bbox + '&realestate_id=' + data.realestate_id + '&appraisal_id=' + data.appraisal_id
            Vue.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(res => resolve(
                {
                    link: res.body

                }), res => {
                console.error(res)
                reject()
            })

        })
    }
    ,
    request_map_urban_muc_council_qual_by_bbox (data) {

        console.log('request_muc_map data in maps_api.js: ')
        console.log(data)

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=

        const factor = 0.2
        const width = data.width * data.zoom * factor
        const height = data.height * data.zoom * factor
        const coord_a1 = data.x - (width / 2)
        const coord_a2 = data.y - (height / 2)
        const coord_b1 = data.x + (width / 2)
        const coord_b2 = data.y + (height / 2)

        const bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2

        return new Promise((resolve, reject) => {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            const url = 'https://us-central1-barnatasa5.cloudfunctions.net/map_urban_muc_council_qual_by_bbox?bbox=' + bbox + '&realestate_id=' + data.realestate_id + '&appraisal_id=' + data.appraisal_id
            Vue.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(res => resolve(
                {
                    link: res.body

                }), res => {
                console.error(res)
                reject()
            })

        })
    }
    ,

    request_map_urban_icc_topo_by_bbox (data) {

        console.log('request_muc_map data in maps_api.js: ')
        console.log(data)

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=
        const factor = 0.2
        const width = data.width * data.zoom * factor
        const height = data.height * data.zoom * factor
        const coord_a1 = data.x - (width / 2)
        const coord_a2 = data.y - (height / 2)
        const coord_b1 = data.x + (width / 2)
        const coord_b2 = data.y + (height / 2)

        const bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2

        return new Promise((resolve, reject) => {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            const url = 'https://us-central1-barnatasa5.cloudfunctions.net/map_urban_icc_topo_by_bbox?bbox=' + bbox + '&realestate_id=' + data.realestate_id + '&appraisal_id=' + data.appraisal_id
            Vue.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(res => resolve(
                {
                    link: res.body

                }), res => {
                console.error(res)
                reject()
            })

        })
    }
    ,
    request_cadastral_reference_by_coordinates (data) {
        console.log('maps_api.js request_cadastral_reference_by_coordinates: ')
        console.log(data)

        function xmlToJson (xml) {

            // Create the return object
            let obj = {}

            if (xml.nodeType == 1) { // element
                // do attributes
                if (xml.attributes.length > 0) {
                    obj['@attributes'] = {}
                    for (let j = 0; j < xml.attributes.length; j++) {
                        const attribute = xml.attributes.item(j)
                        obj['@attributes'][attribute.nodeName] = attribute.nodeValue
                    }
                }
            } else if (xml.nodeType == 3) { // text
                obj = xml.nodeValue
            }

            // do children
            // If just one text node inside
            if (xml.hasChildNodes() && xml.childNodes.length === 1 && xml.childNodes[0].nodeType === 3) {
                obj = xml.childNodes[0].nodeValue
            }
            else if (xml.hasChildNodes()) {
                for (let i = 0; i < xml.childNodes.length; i++) {
                    const item = xml.childNodes.item(i)
                    const nodeName = item.nodeName
                    if (typeof(obj[nodeName]) == 'undefined') {
                        obj[nodeName] = xmlToJson(item)
                    } else {
                        if (typeof(obj[nodeName].push) == 'undefined') {
                            const old = obj[nodeName]
                            obj[nodeName] = []
                            obj[nodeName].push(old)
                        }
                        obj[nodeName].push(xmlToJson(item))
                    }
                }
            }
            return obj
        }

        return new Promise((resolve, reject) => {

            const parser = new DOMParser()

            const srs = 'EPSG:25831'
            const x = data.x.toString()
            const y = data.y.toString()

            // const getUrl = 'http://ovc.catastro.meh.es/ovcservweb/OVCSWLocalizacionRC/OVCCoordenadas.asmx/Consulta_RCCOOR_Distancia?SRS=' + SRS + '&Coordenada_X=' + x + '&Coordenada_Y=' + y
            const getUrl = 'https://us-central1-barnatasa5.cloudfunctions.net/cad_ref_by_coords?srs=' + srs + '&x=' + x + '&y=' + y

            Vue.http.get(getUrl, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(res => resolve(
                {
                    result: xmlToJson(parser.parseFromString(res.body, 'text/xml'))
                }), res => {
                console.error(res.body)
            })

        })
    }

}



// WEBPACK FOOTER //
// ./src/store/maps_api.js